module.exports = __webpack_public_path__ + "img/BoomBounce.7a1d2d01.png";